import { snakeCase } from 'lodash';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { InputNumber } from 'components/atoms/input';
import { Radio } from 'components/atoms/radio';
import {
  Line,
  Lines,
} from 'components/organisms/tasks/criteria/date/components';
import { DateFieldFilterOperationType } from 'components/organisms/tasks/filters/date';
import { RangePickerMenuItem } from './range-picker-item';

interface Props {
  activeType: DateFieldFilterOperationType | null;
  type: DateFieldFilterOperationType;
  setDays: (day: number) => void;
  days: number;
}

const FormattedMessageWrapper = styled.span`
  margin-left: var(--spacing-02);
`;

const DaysInput = styled(InputNumber)`
  padding-left: var(--spacing-02);
  min-width: 96px;
  max-width: 96px;
  margin-right: var(--spacing-03);

  input {
    text-align: right;
    padding-right: var(--spacing-04);
  }
`;

export const relativeRangePicker = ({
  activeType,
  setDays,
  type,
  days,
}: Props): JSX.Element => (
  <RangePickerMenuItem key={type} selected={type === activeType}>
    <Lines>
      <Line>
        <Radio checked={type === activeType} />
        <FormattedMessage
          id={`task_list.filters.${snakeCase(
            DateFieldFilterOperationType[type],
          )}`}
        />
      </Line>
      {type === activeType ? (
        <Line>
          <DaysInput
            onChange={(e) =>
              e !== null && e !== undefined ? setDays(Number(e)) : null
            }
            autoFocus
            value={days}
          />
          <FormattedMessage id="task_list.filters.days" />
          <FormattedMessageWrapper>
            <FormattedMessage id="task_list.filters.ago" />
          </FormattedMessageWrapper>
        </Line>
      ) : null}
    </Lines>
  </RangePickerMenuItem>
);
